function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "37",
  height: "37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 37"
}, props), /*#__PURE__*/React.createElement("ellipse", {
  cx: "18.5",
  cy: "20",
  rx: "16.5",
  ry: "17",
  fill: "#F9F6F2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 18.5C0 8.282 8.282 0 18.5 0 28.717 0 37 8.283 37 18.5c0 9.191-6.704 16.817-15.489 18.255l.083-13.066h4.358l.829-5.208h-5.187V15.1c0-1.426.724-2.815 3.048-2.815H27V7.852S24.86 7.5 22.813 7.5c-4.272 0-7.064 2.495-7.064 7.01v3.97H11v5.21h4.749v13.106C6.836 35.467 0 27.782 0 18.499Z",
  fill: "#600436"
}));